
export class PlanTextInfoGoodsModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * Ｐコード付加情報
   */
  // 商品付随文字情報種別
  public textKindID: string = <string>'';

  // 商品付随文字情報連番
  public textKindNum: string = <string>'';

  // 文字情報
  public stringValue: string = <string>'';
}
